module.exports = __webpack_public_path__ + "img/shaoqiuyan.c490966d.png";